export const localDevHostname = 'localhost.convermax.dev';
export const localDevServerAddress = `https://${localDevHostname}`;
export const localDevPort = 3000;
export const localDevAddress = `${localDevServerAddress}:${localDevPort}`;
export const gatewayServiceName = 'convermax-dev-gateway';
export const heartbeatIntervalMs = 5_000;
